import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { HydrateCriteria, IHydrateCalculator, unitId } from "../../interfaces/interfaces";
import { apiSlice } from "./apiSlice";
import { UnitConverter } from "../../components/MeasurementUnits/UnitConverter";

const initialState: IHydrateCalculator = {
	criteria: {
		id: "hydrate-dd-criteria",
		selected: "towler_mokhatab",
		options: ["towler_mokhatab", "makogon"],
	},
	inputs: [
		{
			id: 'hydrates-pressure',
			type: 'string',
			label: '',
			queryName: 'pressure',
			baseUnitId: 'mpa',
			baseValue: 1.1,
			currentValue: 1.1,
			currentUnitId: 'mpa',
			unitCategoryId: 'pressure',
			userValue: null,
			userUnitId: null,
			min: 1.01325,
		},
		{
			id: 'hydrates-gas-density',
			type: 'string',
			label: '',
			queryName: 'gas_density',
			baseUnitId: null,
			baseValue: 0.56,
			currentValue: 0.56,
			currentUnitId: null,
			unitCategoryId: null,
			userValue: null,
			userUnitId: null,
			min: 0.56,
			max: 1.1
		}
	],
	result: {
		id: "hydrate-result-temperature",
		value: null,
		type: "string",
		label: "",
		queryName: "temperature"
	},
	// results: [
	// 	{
	// 		id: 'hydrates-valanjin',
	// 		type: 'string',
	// 		label: '',
	// 		value: null,
	// 		queryName: 'valanjin'
	// 	},
	// 	{
	// 		id: 'hydrates-senoman',
	// 		type: 'string',
	// 		label: '',
	// 		value: null,
	// 		queryName: 'senoman'
	// 	},
	// 	{
	// 		id: 'hydrates-towler-mokhatab',
	// 		type: 'string',
	// 		label: '',
	// 		value: null,
	// 		queryName: 'towler_mokhatab'
	// 	},
	// ],
	downloadLink: '',
	chartConfig: {},
	requiredSubscriptionLevel: 'free'
}
const converter = new UnitConverter();
const hydratesCalculatorSlice = createSlice({
	name: "hydratesCalculatorSlice",
	initialState,
	selectors: {
	},
	reducers: {
		setInputsData: (state, action: PayloadAction<IHydrateCalculator>) => {
			state.inputs = action.payload.inputs;

			state.result.value = null;
			state.chartsData = null;
		},
		setInputValue: (state, action: PayloadAction<{ inputName: string, value: number | null }>) => {
			state.inputs.forEach(i => {
				if (i.queryName === action.payload.inputName) {
					i.currentValue = action.payload.value;
					i.baseValue = (i.unitCategoryId && action.payload.value != null) ? converter.convert(action.payload.value, i.currentUnitId, i.baseUnitId) : action.payload.value;
					i.userValue = action.payload.value;
					i.userUnitId = i.currentUnitId;
				}
			});

			state.result.value = null;
			state.chartsData = null;
		},
		setInputUnit: (state, action: PayloadAction<{ inputId: string, toUnitId: unitId | null }>) => {
			state.inputs.forEach(i => {
				if (i.id === action.payload.inputId) {
					i.currentValue = i.currentValue != null ? converter.convert(i.currentValue, i.currentUnitId, action.payload.toUnitId) : null;
					i.currentUnitId = action.payload.toUnitId;
					i.baseValue = i.userValue && i.userUnitId
						? converter.convert(i.userValue, i.userUnitId, i.baseUnitId)
						: converter.convert(i.currentValue ?? 0, i.currentUnitId, i.baseUnitId);

					if (i.errorParams?.["min"] && i.min) {
						i.errorParams = { min: converter.convert(i.min, i.baseUnitId, i.currentUnitId) };
					}
					if (i.errorParams?.["max"] && i.max) {
						i.errorParams = { max: converter.convert(i.max, i.baseUnitId, i.currentUnitId) };
					}
				}
			})
		},
		setCriteria: (state, action: PayloadAction<HydrateCriteria>) => {
			state.criteria.selected = action.payload;

			state.result.value = null;
			state.chartsData = null;
		},
		validateInputs: (state) => {
			state.inputs.forEach(input => {
				if (input.min != null && (input.baseValue == null || input.baseValue < input.min)) {
					input.error = "validation.min_value_error";
					input.errorParams = { min: converter.convert(input.min, input.baseUnitId, input.currentUnitId) };
				} else if (input.max != null && input.baseValue != null && input.baseValue > input.max) {
					input.error = "validation.max_value_error";
					input.errorParams = { max: converter.convert(input.max, input.baseUnitId, input.currentUnitId) };
				} else {
					input.error = null;
					input.errorParams = null;
				}
			});
		},
	},
	extraReducers: (builder) => {
		builder
			.addMatcher(apiSlice.endpoints.calculator.matchFulfilled, (state, action) => {
				const params = action.meta.arg.originalArgs as Record<string, string>;
				if (!params?.calculator_type) {
					console.warn("No calculator_type in calculator response");
					return;
				}
				if (params.calculator_type != "hydrate_formation") {
					return;
				}
				if (action.payload) {
					state.result = {
						...state.result,
						value: action.payload.results["temperature"]
					};
					state.chartsData = action.payload.plots[0];
					console.log(state.chartsData)
				}
			})
	}
})

export default hydratesCalculatorSlice

export const {
	setInputsData,
	setCriteria,
	setInputValue,
	setInputUnit,
	validateInputs
} = hydratesCalculatorSlice.actions